"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _r10SourceLibrary = require("r10-source-library");
var _fontFace = _interopRequireDefault(require("@vfuk/core-styles/dist/partials/fontFace"));
var _fontSizes = _interopRequireDefault(require("@vfuk/core-styles/dist/partials/fontSizes"));
var _normalize = _interopRequireDefault(require("@vfuk/core-styles/dist/partials/normalize"));
var _formElementSuggestions = _interopRequireDefault(require("@vfuk/core-styles/dist/partials/formElementSuggestions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable  @typescript-eslint/no-explicit-any */

// stylelint-disable property-no-vendor-prefix
//
const globals = (0, _styledComponents.createGlobalStyle)(props => (0, _styledComponents.css)`
    :where(.gs-app) {
      ${_normalize.default}

      font-family: sans-serif;
      box-sizing: border-box;
      /* stylelint-disable-line */
      -ms-text-size-adjust: 100%;
      -ms-overflow-style: scrollbar;
      /* -webkit-tap-highlight-color: rgba($color-black, 0); */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      font-size: ${props.theme.typography.paragraph[2].fontMobile};
      line-height: ${props.theme.typography.paragraph[2].lineHeightMobile};
      font-family: ${props.theme.baseFont.fontFamily};
      font-weight: ${props.theme.baseFont.fontWeight};
      color: ${props.theme.baseFont.color};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: left;

      ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
        font-size: ${props.theme.typography.paragraph[2].fontTablet};
        line-height: ${props.theme.typography.paragraph[2].lineHeightTablet};
      `)}

      ${_r10SourceLibrary.Mixins.respondTo.lg((0, _styledComponents.css)`
        font-size: ${props.theme.typography.paragraph[2].fontDesktop};
        line-height: ${props.theme.typography.paragraph[2].lineHeightDesktop};
      `)}


      ::-webkit-input-placeholder,
      ::-moz-placeholder,
      :-ms-input-placeholder {
        color: ${props.theme.color.monochrome4.default};
        font-weight: 400;
      }

      ${_fontFace.default}
      ${_fontSizes.default}
      ${_formElementSuggestions.default}
    }

    .gs-app {
      h1,h2{
        font-family: ${props.theme.baseFont.fontFamily};
      }
      select {
        visibility: visible;
      }
    }
    footer[data-selector="sticky-footer"]{
      z-index: 9999;
    }
    ${props.theme.localThemes.hideScrollbar && (0, _styledComponents.css)`
      ::-webkit-scrollbar {
            display: none;
         
          }
      `}
    ${!props.theme.localThemes.hideScrollbar && (0, _styledComponents.css)`
      ::-webkit-scrollbar {
            -webkit-appearance: none;        
          }
      `}
    ::-webkit-scrollbar:vertical {
      width: 12px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 12px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: rgba(128, 128, 128, 0.5);
      border-radius: 10px;
      border: 2px solid #ffffff;
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #ffffff;
    }

    @media(min-width: 768px){
    ${props.theme.localThemes.modalMaxSize && (0, _styledComponents.css)`
      div[class*='ModalRendererstyle__ContainerWrapper'], div[class*='Interactionstyle__BlankInteraction']{
      max-width: ${props.theme.localThemes.modalMaxSize}px;
      }
    `}  
    }  
  `);
var _default = globals;
exports.default = _default;